import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import supabase from "../lib/supabaseClient";

const AuthCallback = () => {
  const history = useHistory();

  useEffect(() => {
    const run = async () => {
      const { data } = await supabase.auth.getSession();
      if (data?.session) history.replace("/dashboard");
      else history.replace("/login");
    };
    run();
  }, [history]);

  return <div style={{ padding: 40, color: "#fff" }}>Signing you in…</div>;
};

export default AuthCallback;
